export default "__VITE_PUBLIC_ASSET__66051199__"